import ApplicationController from '../support/application_controller'

const CARD_NUMBER_LENGTH = 19

export default class extends ApplicationController {

  static targets = [
    'cardNumber',
    'details',
    'rewards'
  ]

  connect() {
    this.scanBuffer = ''
    this.scanLocked = false
    this.onScanKeydown = this.onScanKeydown.bind(this)
    document.addEventListener('keydown', this.onScanKeydown)
  }

  disconnect() {
    document.removeEventListener('keydown', this.onScanKeydown)
    clearTimeout(this.scanTimer)
  }

  cardNumberTargetConnected(element) {
    element.addEventListener('input', () => this.normalizeCardNumber())
    this.focusCardInput()
  }

  // ==== Actions

  focusCard(event) {
    event.preventDefault()
    this.focusCardInput()
  }

  normalizeCardNumber() {
    const input = this.cardNumberTarget
    const digits = input.value.replace(/\D/g, '').slice(0, CARD_NUMBER_LENGTH)
    if (input.value === digits) return

    input.value = digits
  }

  showPatientDetails(event) {
    event.preventDefault()
    this.rewardsTarget.classList.add('u-hide')
    this.detailsTarget.classList.remove('u-hide')
  }

  showRewards(event) {
    event.preventDefault()
    this.detailsTarget.classList.add('u-hide')
    this.rewardsTarget.classList.remove('u-hide')
    this.focusCardInput()
  }

  // ==== Private

  focusCardInput() {
    if (!this.hasCardNumberTarget || !this.cardSearchVisible) return

    this.cardNumberTarget.focus()
  }

  onScanKeydown(event) {
    if (!this.cardSearchVisible || !this.hasCardNumberTarget) return
    if (this.isTypingElsewhere(event)) return

    if (event.key === 'Enter') {
      this.unlockScan()
      this.commitScan()
      return
    }

    if (this.scanLocked) {
      if (this.pressedDigit(event)) event.preventDefault()
      this.holdScanLock()
      return
    }

    const digit = this.digitFromKey(event)
    if (!digit) {
      this.scanBuffer = ''
      return
    }

    if (event.target === this.cardNumberTarget) return

    event.preventDefault()
    this.scanBuffer = (this.scanBuffer + digit).slice(0, CARD_NUMBER_LENGTH)
    clearTimeout(this.scanTimer)

    if (this.scanBuffer.length === CARD_NUMBER_LENGTH) {
      this.commitScan()
      this.holdScanLock()
      return
    }

    this.scanTimer = setTimeout(() => this.commitScan(), 80)
  }

  commitScan() {
    if (!this.scanBuffer) return

    this.cardNumberTarget.value = this.scanBuffer
    this.cardNumberTarget.dispatchEvent(new Event('input', { bubbles: true }))
    this.scanBuffer = ''
    this.focusCardInput()
  }

  digitFromKey(event) {
    if (!this.pressedDigit(event)) return null
    if (/^\d$/.test(event.key)) return event.key

    const code = event.keyCode
    if (code >= 48 && code <= 57) return String(code - 48)
    if (code >= 96 && code <= 105) return String(code - 96)

    return null
  }

  pressedDigit(event) {
    if (/^\d$/.test(event.key)) return true

    const code = event.keyCode
    return (code >= 48 && code <= 57) || (code >= 96 && code <= 105)
  }

  holdScanLock() {
    this.scanLocked = true
    clearTimeout(this.scanTimer)
    this.scanTimer = setTimeout(() => this.unlockScan(), 80)
  }

  unlockScan() {
    this.scanLocked = false
  }

  isTypingElsewhere(event) {
    const target = event.target
    if (target === this.cardNumberTarget) return false

    return target instanceof HTMLInputElement ||
      target instanceof HTMLTextAreaElement ||
      target instanceof HTMLSelectElement ||
      target?.isContentEditable
  }

  get cardSearchVisible() {
    return this.hasRewardsTarget && !this.rewardsTarget.classList.contains('u-hide')
  }

}
